module.exports = __webpack_public_path__ + "img/百花分校@2x.14758ef4.png";